export default __webpack_public_path__ + "static/media/OpenSans-Bold.dbb97fd9.ttf";